import { reactIcons } from '@project44/manifest-ds';

import { MODE_ICON_MAP } from './shipmentSegment';

const routeIcons = {
  [MODE_ICON_MAP.OCEAN]: reactIcons.Boat,
  [MODE_ICON_MAP.RAIL]: reactIcons.Train,
  [MODE_ICON_MAP.LTL]: reactIcons.TruckHalfFull,
  [MODE_ICON_MAP.AIR]: reactIcons.Airplane,
  [MODE_ICON_MAP.TRUCKLOAD]: reactIcons.Truck,
  [MODE_ICON_MAP.PARCEL]: reactIcons.Parcel,
  checkmark: reactIcons.Check,
  locationmark: reactIcons.Location,
  unknown: reactIcons.Route,
  history: reactIcons.Rewind,
};

interface RouteIconProps {
  name: string;
}

export const RouteIcon = ({ name }: RouteIconProps) => {
  const Component = routeIcons[name] || routeIcons['unknown'];
  return <Component data-testid={`${name}-icon`} size="medium" />;
};
